module.exports = __webpack_public_path__ + "img/selected2-min.f6f73512.png";